import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { OwnedFavoritesContent } from "../components/FavoritesContent/OwnedFavoritesContent";
import {
    firstBlockOverlapsNav,
    isOverlapBlockType,
} from "../components/HeaderNav/overlap";
import { PageSkeleton } from "../components/PageSkeleton";
import { toolboxComponents } from "../components/PageSkeleton/Toolbox";

import styles from "../styles/favorites-page.module.scss";

export const Template = (props: templates.FavoritesPageTemplate) => (
    <PageSkeleton
        {...props.page}
        overlapNav={firstBlockOverlapsNav(
            props.page.body.value.slice(0, 1).find(isOverlapBlockType),
        )}
        rootClassName={styles.favoritesPage}
    >
        <StreamField
            tagName={React.Fragment}
            value={props.page.body.value}
            components={{
                ...toolboxComponents,
                favorites_content: ({ value }) => (
                    <OwnedFavoritesContent
                        value={value}
                        subcategoryTiles={props.page.subcategory_tiles}
                        productsPageTitle={props.page.products_page_title}
                        gridPromos={props.page.grid_promos.value}
                    />
                ),
            }}
        />
    </PageSkeleton>
);
